import {DocumentType, FileEntity, FileTag, FileTagEntity, UsedFileTag} from '@pages/FilesPage';
import api, {instance} from 'utils/api';
import {AxiosProgressEvent, AxiosResponse} from 'axios';

const ROOT_URL = '/my-resources';

export const getEmployeeFileTags = (employeeId: string): Promise<FileTag[]> => {
    return api.get(`${ROOT_URL}/files/tags`, {employeeId});
};
export const addEmployeeFileTag = (title: string, employeeId: string): Promise<FileTagEntity> => {
    return api.post(`${ROOT_URL}/files/tags`, {title, employeeId});
};
export const deleteEmployeeFileTag = (tagId: string): Promise<void> => {
    return api.delete(`${ROOT_URL}/files/tags/${tagId}`);
};

export const isUsedEmployeeFileTag = (tagId: string): Promise<UsedFileTag> => {
    return api.get(`${ROOT_URL}/files/tags/${tagId}/isUsed`);
};
export const updateEmployeeFile = (
    id: string,
    documentDate: string,
    tagIds: string[],
    type: DocumentType,
): Promise<FileEntity> => {
    return api.put(`${ROOT_URL}/file/${id}`, {documentDate, tagIds, type});
};

export const createFile = async (
    data: FormData,
    params: Record<string, string | number | undefined>,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
    signal?: AbortSignal,
): Promise<void> => {
    try {
        await instance({
            method: 'POST',
            url: `${ROOT_URL}/file/upload`,
            data,
            params,
            onUploadProgress,
            signal,
            withoutGlobalLoader: true,
        });
    } catch (error) {
        console.error('File upload failed:', error);
        throw error;
    }
};

export const deleteFile = async (id: string): Promise<void> => {
    await api.delete(`/my-resources/file/${id}/delete-file`);
};
export const downloadEmployeeFileFromTable = (link: string): Promise<AxiosResponse<string>> => {
    return instance.get(link, {
        responseType: 'blob',
        errorMessage: 'Не удалось скачать шаблон',
    });
};
